import { BillingCadence } from '@/services/billing/cadence';

// Capitalizes the first letter of each word. A hyphen stays as it is: "semi-annual" becomes
// "Semi-annual".
function titleCase(value: string): string {
  return value
    .split(' ')
    .map((word) => (word.length === 0 ? word : `${word[0].toUpperCase()}${word.slice(1)}`))
    .join(' ');
}

/**
 * The plan title with its cadence, for example "Monthly plan".
 *
 * An unknown cadence gives "Plan" and not "Unknown plan". Shared by the two tabs that title an ACH
 * plan, so that both use the same name for a given cadence.
 */
export function planCadenceTitle(cadence: BillingCadence): string {
  if (cadence === BillingCadence.Unknown) {
    return 'Plan';
  }
  return `${titleCase(cadence)} plan`;
}
